import { generateUuid, Uuid } from '@ftr/contracts/type/shared'
import { RealTimeSttSegmentMap } from '../../../types'
import { TransactionResult } from './operation-result'

export interface UpdateRemarkSpeakerOperation {
  type: 'updateRemarkSpeaker'
  remarkId: Uuid
  newSpeakerId: Uuid
}

export function updateRemarkSpeakerTransaction(
  operation: UpdateRemarkSpeakerOperation,
  segmentMap: RealTimeSttSegmentMap,
): TransactionResult {
  // Find the remark in the segment map
  const remark = segmentMap.findRemark(operation.remarkId)
  if (!remark) {
    throw new Error(`Remark with ID ${operation.remarkId} not found in segment map`)
  }
  return {
    type: 'transaction',
    transaction: {
      id: generateUuid(),
      edits: [
        {
          type: 'upsertUtterance',
          utteranceId: operation.remarkId,
          dialect: remark.dialect ?? null,
          fragments: remark.fragments!,
          speakerId: operation.newSpeakerId,
        },
      ],
    },
    sideEffects: [],
  }
}
